module.exports = __webpack_public_path__ + "media/images/btso-305a3bd724ede1f822296c6dafc2915d.png";